import { render } from "./WorkbookDetails.vue?vue&type=template&id=498630b6&lang=true"
import script from "./WorkbookDetails.vue?vue&type=script&lang=js"
export * from "./WorkbookDetails.vue?vue&type=script&lang=js"

import "./WorkbookDetails.vue?vue&type=style&index=0&id=498630b6&scope=true&lang=css"
script.render = render

export default script